<h2 mat-dialog-title>You could not log it</h2>
<mat-dialog-content>Error: {{ data.dialogtext }}</mat-dialog-content>
<mat-dialog-actions>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Try Again</button>    
  </mat-dialog-actions>